export default "__VITE_ASSET__1260ca69__"